import Vue from 'vue'
import Router from 'vue-router'
import {isWeChat, setCookie, getCookie} from '@/assets/js/util'
import wechat from '@/api/wechat'

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    // {
    //   path: '/',
    //   name: 'list',
    //   meta: {
    //     auth: false,
    //     title: "腾讯公益项目列表",
    //   },
    //   component: () => import('@/page')
    // },
    // {
    //   path: '/foundation',
    //   name: 'foundation',
    //   meta: {
    //     auth: false,
    //     title: "公益项目列表",
    //   },
    //   component: () => import('@/page/foundation')
    // },
    {
      path: '/detail',
      name: 'detail',
      meta: {
        auth: false,
        title: "公益项目详情",
      },
      component: () => import('@/page/detail')
    },
    {
      path: '/gy',
      name: 'gy',
      meta: {
        auth: false,
        title: "公益项目",
      },
      component: () => import('@/page/gy/index')
    },
    {
      path: '/fullPage',
      name: 'fullPage',
      meta: {
        auth: false,
        title: "公益项目",
      },
      component: () => import('@/page/fullPage')
    },
    {
      path: '/',
      name: 'fullPageNew',
      meta: {
        auth: false,
        title: "公益项目",
      },
      component: () => import('@/page/fullPageNew')
    },
    {
      path: '/scrollPage',
      name: 'scrollPage',
      meta: {
        auth: false,
        title: "Help Now!",
      },
      component: () => import('@/page/scrollPage')
    },
    {
      path: '/payEN',
      name: 'payEN',
      meta: {
        auth: false,
        title: "支付页",
      },
      component: () => import('@/page/payEN')
    },
    {
      path: '/monthReturn/:id',
      name: 'monthReturn',
      meta: {
        auth: false,
        title: "",
      },
      component: () => import('@/page/monthReturn/index')
    },
    {
      path: '/choose/:id',
      name: 'choose',
      meta: {
        auth: false,
        title: "",
      },
      component: () => import('@/page/choose')
    },
    {
      path: '/pay/:id/:type',
      name: 'pay',
      meta: {
        auth: false,
        title: "支付页",
      },
      component: () => import('@/page/pay')
    },
    {
      path: '/payZfb/:id',
      name: 'payZfb',
      meta: {
        auth: false,
        title: "支付宝支付页",
      },
      component: () => import('@/page/payZfb')
    },
    {
      path: '/success/:id/:fid',
      name: 'success',
      meta: {
        auth: false,
        title: "",
      },
      component: () => import('@/page/success')
    },
    {
      path: '/donnationgift',
      name: 'donnationgift',
      meta: {
        auth: false,
        title: "安迪曼邀您助力公益",
      },
      component: () => import('@/page/donationGift')
    },
    {
      path: '/bill',
      name: 'bill',
      meta: {
        auth: false,
        title: "捐赠发票申请表",
      },
      component: () => import('@/page/bill')
    },
    {
      path: '/gift/:fid/:type',
      name: 'gift',
      meta: {
        auth: false,
        title: "爱心礼品",
      },
      component: () => import('@/page/gift')
    },
    {
      path: '/certificate',
      name: 'certificate',
      meta: {
        auth: false,
        title: "乡村助学 有你有我",
      },
      component: () => import('@/page/bill/certificate')
    },
    {
      path: '/certApply',
      name: 'certApply',
      meta: {
        auth: false,
        title: "证书选择",
      },
      component: () => import('@/page/bill/certApply')
    },
    {
      path: '/connect',
      name: 'connect',
      meta: {
        auth: false,
        title:"联系我们",
      },
      component: () => import('@/page/connect')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && !to.meta.isRefresh) {
      return savedPosition;
    }
    ;
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({x: 0, y: 1});
      }, 0);
    });
  },
})

router.beforeEach(async (to, from, next) => {
  if (to.query.token) {
    setCookie("uuid", to.query.token)
  }
  if (!sessionStorage.getItem('initLink')) {
    let url = document.URL
    if (url.indexOf("#") > -1) url = url.split("#")[0]
    sessionStorage.setItem('initLink', url)
  }
  if (isWeChat()) {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      await wechat.wxInit(encodeURIComponent(sessionStorage.getItem('initLink')))
    } else {
      await wechat.wxInit(encodeURIComponent(location.href))
    }
  }
  //登入状态
  next()
})
router.afterEach(async (to, from) => {
  //数据统计
  if (_hmt) {
    _hmt.push(['_trackPageview', '/foundation/web' + to.fullPath]);
  }
  let type = Vue.prototype.project
  if (isWeChat()) {
    wxshares(to)
  }
})

function wxshares(to) {
  let type = Vue.prototype.project
  let link = `https://${location.host}/foundation/web${localStorage.getItem('index')}`;
  let detail = localStorage.getItem("foundation_Detail");
  if ((to.name == "detail" || to.name == "fullPageNew") && detail) {
    wechat.wxShare({
      title: JSON.parse(detail).title, // 分享标题
      desc: JSON.parse(detail).desc,
      link: link, // 分享链接
      imgUrl: JSON.parse(detail).img // 分享图标
    })
  } else if (to.name == "donnationgift") {
    wechat.wxShare({
      title: "安迪曼邀您助力公益", // 分享标题
      desc: "赠人玫瑰，手有余香。每8元可帮助一个贫困儿童获取一份所需的学习物资",
      link: `https://app.sxfoundation.com/donnationgift`, // 分享链接
      imgUrl: 'https://cdn2.liuliangbang.vip/picture/3f21b9618e0ca51e6f194afae1273ebc-1616482835756.png' // 分享图标
    })
  } else if (to.name == "certificate" || to.name === "certApply") {
    let type = to.query.type || to.params.type
    wechat.wxShare({
      title: '乡村助学获奖证书已开始申请', // 分享标题
      desc: '',
      link: `https://app.sxfoundation.com/certificate?type=${type}`, // 分享链接
      imgUrl: 'https://app.sxfoundation.com/shanxing.png' // 分享图标
    })
  } else {
    wechat.wxShare({
      title: Vue.prototype.officialAccount, // 分享标题
      desc: "",
      link: link, // 分享链接
      imgUrl: `https://${location.host}/${type}.png`
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js